import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorCargasService } from 'src/app/services/mantenedor-cargas/mantenedor-cargas.service';
import {Observable,of, Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import {map,tap ,startWith} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Usuario } from '../../models/usuario/usuario.model';
export interface DialogData
{
    carga: any
    sexo: any
    recarga: boolean
    tipoCarga: any
    usuarios: any
    rolUsuario:string
    idEjecutivo:any
}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-cargas/edita-carga.component.html',
    styleUrls: ['../../pages/mantenedor-cargas/mantenedor-cargas.component.css']
})
export class DialogEditaCarga implements OnInit
{
    carga: any = { nombre:this.data.carga.nombre, apellido: this.data.carga.apellido,
                   rut: this.data.carga.rut + '-' + this.data.carga.dv, sexo: this.data.carga.idSexo,
                   tipoCarga: this.data.carga.idTipoCarga,
                   fechaCreacion: this.data.carga.fechaCreacion,
                   fechaNacimiento: this.data.carga.fechaNacimiento, fechaDefuncion: this.data.carga.fechaDefuncion,
                   parentesco: this.data.carga.parentesco, fechaExpiracion: this.data.carga.fechaExpiracion,
                   usuario: this.data.carga.idUsuario, idEjecutivo: this.data.carga.idEjecutivo }
    termino: string  = '';

    usuarios: any = { nombres:null, apellidoPaterno: null, apellidoMaterno: null, rut: null, correo: null,
        tipoAfiliado: null, estadoAfiliado: 'Afiliado', sexo: null, estadoCivil: null,
        fechaIngreso: null, fechaNacimiento: null, fonoFijo: null, fonoMovil: null, prevision: null ,
        direccion: { descripcion: null, comuna: null, region: null, numero: null, sistemaSalud: null ,
        descripcionAdicional: null }, datosLaborales: { tipoUnidad: null, unidad: null,
        calidadJuridica: null, estamento: null, direccion: { descripcion: null, comuna: null,
        region: null, numero: null, descripcionAdicional: null } }, rol: null }

    constructor( public dialogRef: MatDialogRef<DialogEditaCarga>, private dialog: MatDialog,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private mantenedorService: MantenedorCargasService)
    {
        this.data.recarga = false
        this.data.usuarios = null
        this.data.rolUsuario = localStorage.getItem('rol')
        this.data.idEjecutivo = localStorage.getItem("idUsuario")
        this.data.sexo = [ { descripcion: 'Hombre', id: '1' }, { descripcion: 'Mujer', id: '2' } ]
    }

    ngOnInit(): void {
        let vm = this
        this.loadData()
        this.termino=this.data.carga.nombreTitular+ ' ' +this.data.carga.apellidoPaternoTitular +
        ' , ' + this.data.carga.rutTitular+'-' + this.data.carga.dvTitular
    }

    loadData()
    {
        let vm = this
        this.mantenedorService.traeTipoCarga().then( tipo => vm.data.tipoCarga = tipo )
    }

    buscandor() {
        let vm = this
        this.mantenedorService.traerUsuarioSugerido( this.termino.trim() )
            .subscribe( usuarios => vm.data.usuarios = usuarios );
    }

    opcionSeleccionada( event: MatAutocompleteSelectedEvent ) {
        if(!event.option.value) {
            this.usuarios = undefined;
            return;
        }
        const user = event.option.value;
    }

editarCarga(): void{

        let fd = new Date(this.carga.fechaDefuncion);
        let fc = new Date(this.carga.fechaCreacion);
        let fe = new Date(this.carga.fechaExpiracion);
        let fn = new Date(this.carga.fechaNacimiento);
         if(this.data.idEjecutivo){
            this.carga.idEjecutivo = this.data.idEjecutivo
        }
    if(fc.getTime() < fe.getTime()){
        if(isNaN(fd.getTime()) || (!isNaN(fd.getTime()) && fd.getTime() > fn.getTime())){
            if(fn.getTime() <= fc.getTime()){
                if(fe.getTime() > fn.getTime()){
                    if(Rut( this.carga.rut)){
                            let vm = this
                            let rutTitular= null
                            let fechaDefuncion =""
                            rutTitular= vm.termino.split(',')[1]
                            this.carga.rutTitular = rutTitular.split('-')[0]
                            let fechaNacimiento = this.carga.fechaNacimiento.split('-')[2] + '-' +
                                                this.carga.fechaNacimiento.split('-')[1] + '-' +
                                                this.carga.fechaNacimiento.split('-')[0]

                            let fechaCreacion = this.carga.fechaCreacion.split('-')[2] + '-' +
                                            this.carga.fechaCreacion.split('-')[1] + '-' +
                                            this.carga.fechaCreacion.split('-')[0]

                            if(this.carga.fechaDefuncion && this.carga.fechaDefuncion.length>0){
                                fechaDefuncion = this.carga.fechaDefuncion.split('-')[2] + '-' +
                                this.carga.fechaDefuncion.split('-')[1] + '-' +
                                this.carga.fechaDefuncion.split('-')[0]
                            }
                            let fechaExpiracion = this.carga.fechaExpiracion.split('-')[2] + '-' +
                                            this.carga.fechaExpiracion.split('-')[1] + '-' +
                                            this.carga.fechaExpiracion.split('-')[0]

                            this.carga.fechaNacimiento = fechaNacimiento, this.carga.fechaCreacion = fechaCreacion
                            if(this.carga.fechaDefuncion){
                                this.carga.fechaDefuncion = fechaDefuncion
                            }else{
                                this.carga.fechaDefuncion = ""
                            }
                            this.carga.fechaExpiracion = fechaExpiracion
                            this.carga.id=this.data.carga.id

                            this.mantenedorService.editarCarga(this.carga).then

                            (
                                () =>
                                {
                                    vm.openAlertDialog('Se ha editado correctamente la carga familiar.', 'btn-success')

                                    vm.data.recarga = true
                                    vm.dialogRef.close()
                                }
                            )
                            .catch ( error =>
                            {
                                console.log(error)

                                vm.openAlertDialog('Ha ocurrido un error al editar el usuario', 'btn-danger')

                                vm.dialogRef.close()
                            })
                    }else{
                        this.openAlertDialog('El RUT de la carga familiar es incorrecto. Favor Revisar', 'btn-danger')
                    }
                }else{
                    this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de expiración', 'btn-danger')
                }
            }else{
                this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger')
            }
        }else{
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de defunción', 'btn-danger')
        }
    }else{
        this.openAlertDialog('La fecha de expiración debe ser mayor a la fecha de ingreso', 'btn-danger')
    }
}

    onCancelarClick(): void { this.dialogRef.close() }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
